module.exports = __webpack_public_path__ + "img/Rectangle17190.548ba920.png";